export const isAdmin = function (state) {
  return state.adminStatus
}

export const userId = function (state) {
  return state.userId
}

export const userName = function (state) {
  return state.userName
}

export const allpackinstalledCount = function (state) {
  return state.packinstalled.length
}

export const successpackinstalledCount = function (state) {
  return state.packinstalled.filter(
      p => (
        p.LastRunResult.toLowerCase() === 'success' &&
        p.NbDayLastRun <= 4
      )
  ).length
}

export const warningpackinstalledCount = function (state) {
  return state.packinstalled.filter(
      p => (
        p.LastRunResult.toLowerCase() === 'success' &&
        p.NbDayLastRun > 4 &&
        p.NbDayLastRun <= 7
      )
  ).length
}

export const errorpackinstalledCount = function (state) {
  return state.packinstalled.filter(
      p => (
        p.LastRunResult.toLowerCase() === 'error' ||
        p.NbDayLastRun > 7
      )
  ).length
}

export const backupAlarmLevel = (state) => (p) => {
  if (p.LastRunResult.toLowerCase() === 'success' &&
      p.NbDayLastRun <= 4) {
    return 'SUCCESS'
  } else if (p.LastRunResult.toLowerCase() === 'success' &&
           p.NbDayLastRun > 4 &&
           p.NbDayLastRun <= 7) {
    return 'WARNING'
  } else if (p.LastRunResult.toLowerCase() === 'error' ||
           p.NbDayLastRun > 7) {
    return 'ERROR'
  } else {
    return 'UNKNOWN'
  }
}

export const listOfBackupPackInstalled = function (state) {
  return state.packinstalled
    .sort((a, b) =>
      a.NbDayLastRun < b.NbDayLastRun ? 1
        : a.NbDayLastRun > b.NbDayLastRun ? -1
        : 0
    )
    .sort((a, b) =>
      a.LastRunResult.toLowerCase() !== 'error' && b.LastRunResult.toLowerCase() === 'error' ? 1
        : a.LastRunResult.toLowerCase() === 'error' && b.LastRunResult.toLowerCase() !== 'error' ? -1
        : 0
    )
    // .slice(0, 10)
}

export const allservicemonitoringCount = function (state) {
  return state.servicemonitoring.length
}

export const successservicemonitoringCount = function (state) {
  var tzOffset = new Date().getTimezoneOffset()
  return state.servicemonitoring.filter(
      p => (
        p.TimeSinceLastHB - tzOffset <= p.WarningThreshold
      )
  ).length
}

export const warningservicemonitoringCount = function (state) {
  var tzOffset = new Date().getTimezoneOffset()
  return state.servicemonitoring.filter(
      p => (
        p.TimeSinceLastHB - tzOffset > p.WarningThreshold &&
        p.TimeSinceLastHB - tzOffset <= p.ErrorThreshold
      )
  ).length
}

export const errorservicemonitoringCount = function (state) {
  var tzOffset = new Date().getTimezoneOffset()
  return state.servicemonitoring.filter(
      p => (
        p.TimeSinceLastHB - tzOffset > p.ErrorThreshold
      )
  ).length
}

export const servicemonitoringAlarmLevel = (state) => (p) => {
  var tzOffset = new Date().getTimezoneOffset()
  if (p.TimeSinceLastHB - tzOffset <= p.WarningThreshold) {
    return 'SUCCESS'
  } else if (p.TimeSinceLastHB - tzOffset > p.WarningThreshold &&
             p.TimeSinceLastHB - tzOffset <= p.ErrorThreshold) {
    return 'WARNING'
  } else if (p.TimeSinceLastHB - tzOffset > p.ErrorThreshold) {
    return 'ERROR'
  } else {
    return 'UNKNOWN'
  }
}

export const listOfservicemonitoring = function (state) {
  var tzOffset = new Date().getTimezoneOffset()
  return state.servicemonitoring
    .sort((a, b) => {
      if (a.ErrorThreshold - (a.TimeSinceLastHB - tzOffset) > b.ErrorThreshold - (b.TimeSinceLastHB - tzOffset)) {
        return 2
      } else if (a.ErrorThreshold - (a.TimeSinceLastHB - tzOffset) < b.ErrorThreshold - (b.TimeSinceLastHB - tzOffset)) {
        return -2
      } else if (a.WarningThreshold - (a.TimeSinceLastHB - tzOffset) > b.WarningThreshold - (b.TimeSinceLastHB - tzOffset)) {
        return 1
      } else if (a.WarningThreshold - (a.TimeSinceLastHB - tzOffset) < b.WarningThreshold - (b.TimeSinceLastHB - tzOffset)) {
        return -1
      } else {
        return 0
      }
    }
    )
}



// WEBPACK FOOTER //
// ./src/store/getters.js